import { DEFAULT_AGENT_TIME_RANGE } from './constants';

import type { AgentLogsFilters } from '~/api/agentLogs/types';
import { calculateDateRange } from '~/scenes/Monitor/scenes/PipelineLogs/hooks/dateRangeUtils';

export type AgentLogsFilterState = {
  pipelineName: string;
  agentName: string;
  content: string;
  time: string;
  dateFrom: string | null;
  dateTo: string | null;
};

export type AgentLogsQueryParams = {
  filters: AgentLogsFilters;
  dateFrom: string;
  dateTo: string;
};

function buildPipelineNameFilter(
  pipelineName: string
): Pick<AgentLogsFilters, 'pipelineName' | 'searchType'> {
  let name = pipelineName;
  let searchType: AgentLogsFilters['searchType'];

  if (pipelineName) {
    if (pipelineName.startsWith('*') && pipelineName.endsWith('*')) {
      const stripped = pipelineName.slice(1, -1);
      if (stripped) {
        name = stripped;
        searchType = 'LIKE';
      } else {
        name = '';
      }
    } else {
      searchType = 'EXACT';
    }
  }

  return {
    ...(name && { pipelineName: name }),
    ...(name && searchType && { searchType })
  };
}

export function mapAgentLogsFiltersToQueryParams({
  pipelineName,
  agentName,
  content,
  time,
  dateFrom,
  dateTo
}: AgentLogsFilterState): AgentLogsQueryParams {
  const resolvedDates =
    dateFrom && dateTo
      ? {
          dateFrom: decodeURIComponent(dateFrom),
          dateTo: decodeURIComponent(dateTo)
        }
      : calculateDateRange(time || DEFAULT_AGENT_TIME_RANGE, null);

  const filters: AgentLogsFilters = {
    ...buildPipelineNameFilter(pipelineName),
    ...(agentName && { stepName: agentName }),
    ...(content && { logMessage: content })
  };

  return {
    filters,
    dateFrom: resolvedDates.dateFrom,
    dateTo: resolvedDates.dateTo
  };
}
